// extracted by mini-css-extract-plugin
export var bodySections = "_eb-8";
export var gray = "_eb-7";
export var green = "_eb-4";
export var iconContainer = "_eb-9";
export var iconWidgetContainer = "_eb-1";
export var phoneIcon = "_eb-2";
export var red = "_eb-5";
export var statusDot = "_eb-3";
export var widgetContainer = "_eb-0";
export var yellow = "_eb-6";